export default () => {
  const date = new Date;
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  date.setMonth(date.getMonth() - 1);

  return date;
}
